import { SET_SHOW_LISA_LOADING } from '../actionTypes';
import { lisaFilesActions } from '../reducer';

export default (value) => lisaFilesActions[SET_SHOW_LISA_LOADING](value);
